import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'


import Pagination from '../Paginations';
import { snakeToCamel } from './AdminEditRelease';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { getReportsOverview } from '../../api/reports';
import { CircularProgress, Alert } from '@mui/material';


const AdminReportsDetails = () => {
    const {month_year} = useParams()
    const {data:reports = [], isLoading, error} = useQuery({
        queryKey: ['reports_overview', month_year],
        queryFn: () => getReportsOverview(month_year),
        select: (data) => data.reports.map((report) => ({
            payeeID: report.payee_id,
            ...snakeToCamel(report),
           
        })),
    })
    /////////// PAGINATION ///////////
    const itemsPerPage = 50;
    const [currentPage, setCurrentPage] = useState(1);

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = reports.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(reports.length / itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };


  return (
    <div className='dash-section'>
        <h1 className='dash-title'>Uploaded Reports</h1>
        <div className="row">
            <div className="col-12 mt-4">
                <div className="dash-card">
                    <h2 className="dash-card-title">
                        <Link to={'/admin/reportsHistory'} className='title-back-link'>
                            <i className="fi fi-rr-arrow-small-left"></i>
                        </Link>
                        Report Overview
                    </h2>
                    <div className="table-responsive mt-3">
                        <table className="table dash-table">
                            <thead>
                                <tr>
                                    <td>Email</td>
                                    <td>Name</td>
                                    <td>Payee ID</td>
                                    <td>Total Streams</td>
                                    <td>Net Revenue</td>
                                    <td>Gross Revenue</td>
                                </tr>
                            </thead>
                            <tbody>
                                {/* Loading State */}
                                {isLoading && (
                                    <tr>
                                        <td colSpan="6">
                                            <div style={{ display: 'flex', justifyContent: 'center', padding: '50px 0' }}>
                                                <CircularProgress />
                                            </div>
                                        </td>
                                    </tr>
                                )}

                                {/* Error State */}
                                {error && (
                                    <tr>
                                        <td colSpan="6">
                                            <Alert 
                                                severity="error" 
                                                sx={{ margin: '20px 0' }}
                                            >
                                                {error.message || 'An error occurred while fetching reports data'}
                                            </Alert>
                                        </td>
                                    </tr>
                                )}

                                {/* Data Table */}
                                {!isLoading && !error && currentItems.length === 0 && (
                                    <tr>
                                        <td colSpan="6">
                                            <Alert 
                                                severity="info" 
                                                sx={{ margin: '20px 0' }}
                                            >
                                                No reports data found for this period
                                            </Alert>
                                        </td>
                                    </tr>
                                )}

                                {!isLoading && !error && currentItems.length > 0 && 
                                    currentItems.map((user, i) => (
                                        <tr key={i}>
                                            <td>{user.usersProfile.email}</td>
                                            <td>{user.usersProfile.first_name + " " + user.usersProfile.last_name}</td>
                                            <td>{user.usersProfile.payee_id}</td>
                                            <td>{user.streams}</td>
                                            <td>${user.netRevenue}</td>
                                            <td>${user.grossRevenue}</td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                    <Pagination currentPage={currentPage} totalPages={totalPages} handlePageChange={handlePageChange} />
                </div>
            </div>
        </div>

    </div>
  )
}

export default AdminReportsDetails